import type { ClaimWithRelations } from "../../api/use-claim";

/** Port of the « Réservation » summary block of PassengerTable.vue. */
export function ReservationSummary({ claim }: { claim: ClaimWithRelations }) {
  const reservation = claim.legalSpecification.impactedSegment.reservation;

  return (
    <div className="mt-4">
      <div className="rounded-md border bg-gray-50 py-4 sm:grid sm:grid-cols-3 sm:py-5">
        <dt className="px-4 text-sm font-medium text-gray-500">
          Réservation
          {reservation.tags?.length ? (
            <div className="mt-1 flex flex-wrap gap-1">
              {reservation.tags.map((tag) => (
                <span
                  key={tag}
                  className="inline-flex items-center rounded-md bg-pink-50 px-2 py-0.5 text-xs font-medium text-pink-700 ring-1 ring-inset ring-pink-600/10"
                >
                  {tag}
                </span>
              ))}
            </div>
          ) : null}
        </dt>
        <dd className="mt-1 text-sm text-gray-700 sm:col-span-2 sm:mt-0">
          <p>
            PNR : <span className="font-medium">{reservation.gdsPnrId}</span>
          </p>
          {reservation.thirdId ? (
            <p>
              Réf. dossier agence : <span className="font-medium">{reservation.thirdId}</span>
            </p>
          ) : null}
          <p>
            Office : <span className="font-medium">{reservation.travelAgencyOffice.amadeusOfficeId}</span> (
            {reservation.travelAgencyOffice.name})
          </p>
          {reservation.travelAgencyAgent ? (
            <p>
              Agent :{" "}
              <span className="font-medium">
                {reservation.travelAgencyAgent.admin.fullName || "(inconnu)"}
              </span>{" "}
              <span>({reservation.travelAgencyAgent.admin.email})</span>
            </p>
          ) : null}
          {reservation.travelAgencyCompany?.bluebizIdentifier ? (
            <p>
              OSI OIN :{" "}
              <span className="font-medium">{reservation.travelAgencyCompany.bluebizIdentifier}</span>
            </p>
          ) : null}
          {reservation.travelAgencyCompany ? (
            <p>
              Entreprise : <span className="font-medium">{reservation.travelAgencyCompany.displayName}</span>
            </p>
          ) : null}
          {reservation.subAccount ? (
            <p className="pl-6">
              ↳ Sous-compte : <span className="font-medium">{reservation.subAccount.rawGdsName}</span>
            </p>
          ) : null}
        </dd>
      </div>
    </div>
  );
}
